import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';

import Arranger from '~c/components/base/arranger';
import Text from '~c/components/base/text';

export interface OverlayProps {
  /**
   * title will be displayed in the center of doughnut chart
   */
  title?: React.ReactNode;
  /**
   * description will be displayed below the title
   */
  description?: React.ReactNode;
}

interface Props extends OverlayProps {
  className?: string;
  /**
   * width of overlay
   */
  width: number;
}

const OverlayImpl: React.FC<Props> = ({ className, title, description }) => {
  const renderableInText = (
    input?: React.ReactNode
  ): input is React.ReactNode =>
    typeof input === 'string' || typeof input === 'number';

  return (
    <Arranger
      className={className}
      direction="column"
      justify="center"
      alignItems="center"
    >
      {renderableInText(title) ? (
        <Text sz="h3" align="center">
          {title}
        </Text>
      ) : (
        title
      )}
      {renderableInText(description) ? (
        <Text sz="body14" align="center">
          {description}
        </Text>
      ) : (
        description
      )}
    </Arranger>
  );
};

export const Overlay = muiStyled(OverlayImpl)(
  ({ theme, width }) => css`
    position: absolute;
    width: ${width}px;
    height: ${width}px;
    pointer-events: none;

    /* Make sure nothing render outside the donut inner radius */
    border-radius: 50%;
    overflow: hidden;
  `
);

export default Overlay;
